import _ from 'lodash';

import React from 'react';
import { Helmet } from 'react-helmet';

const SynthegoTags = ({ stack, title, description, image }) => {
  const defaultImage =
    _.get(stack, 'hero_image.url') ||
    _.get(stack, 'main_image.url') ||
    _.get(stack, 'image.url') ||
    'https://images.contentstack.io/v3/assets/blte41c17d7f8dda379/blt6eaeee4d25cb2c6f/5b108d0edc1dd5cd0f3cafad/OG_Image@2x.png';

  const defaultTitle = stack.title || 'Full Stack Genome Engineering';
  const defaultDescription = stack.description
    ? stack.description.replace(/<[^>]+>/g, '')
    : stack.excerpt || '';

  const getMeta = meta => {
    switch (meta) {
      case 'title':
        return title || stack?.meta?.title || defaultTitle;
      case 'description':
        return description || stack?.meta?.description || defaultDescription;
      case 'image':
        return (
          image ||
          _.get(
            stack.meta,
            'image.url',
            `${defaultImage}?format=pjpg&width=1200&height=630&fit=crop`
          )
        );
      default:
        return '';
    }
  };

  return stack.meta || title || description || image ? (
    <Helmet>
      <title>{getMeta('title')}</title>
      <meta name="description" content={getMeta('description')} />
      <meta property="og:site_name" content="Synthego" />

      <meta property="og:title" content={getMeta('title')} />
      <meta property="og:description" content={getMeta('description')} />
      <meta property="og:image" content={getMeta('image')} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@synthego" />
      <meta name="twitter:title" content={getMeta('title')} />
      <meta name="twitter:description" content={getMeta('description')} />
      <meta name="twitter:image" content={getMeta('image')} />
    </Helmet>
  ) : null;
};

export default SynthegoTags;
